import { useTranslation } from "@coworker/locales";
import {
  BooleanFilterValue,
  CheckboxFilter,
  FilterType,
  InputType,
} from "@coworker/apprestructured/src/shared/filters/types/filter";

export const PRODUCT_QUALITY_ID = "productQuality";

function useProductQualityFilter(enabled: boolean): CheckboxFilter {
  const { t } = useTranslation();

  const defaultValue = {
    filterId: PRODUCT_QUALITY_ID,
    value: false,
  } as BooleanFilterValue;

  return {
    inputType: InputType.Checkbox,
    filterType: FilterType.Filter,
    id: PRODUCT_QUALITY_ID,
    title: t("productQualityTeamString"),
    defaultValue,
    enabled,
  };
}

export default useProductQualityFilter;
